import React, { useContext, useEffect, useState } from "react";

import GlobalContext from "shared/providers/context/GlobalContext";

import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";

import {
  Container,
  Paragraph,
  ParagraphAlertInterest,
  ShieldIcon,
  Strong,
  Title,
  TitleContainer,
} from "./styles";

const MoreInformations = () => {
  const { state } = useContext(GlobalContext);

  const interest = state?.tenancy?.plan?.pf_credit_card_interest;

  const {
    steps,
    offer,
    installments,
    installmentSelected,
    orderBumpsInstallmentSelected,
    orderBumpsSelected,
  } = useCheckoutStepsOffersContext();
  const [showMessagesInterestRate, setShowMessagesInterestRate] =
    useState(false);

  useEffect(() => {
    const hasInterestRate = Object.values(orderBumpsInstallmentSelected).some(
      (item) =>
        item?.installment?.installment > 1 &&
        !item?.installment?.free_installment,
    );

    setShowMessagesInterestRate(
      hasInterestRate && orderBumpsSelected?.length > 0,
    );
  }, [orderBumpsInstallmentSelected]);

  const lastInstallment = installments[installments?.length - 1];

  const tenantData = state?.tenancy;
  const site = tenantData?.settings?.site;
  const supportEmail = tenantData && site?.supportEmail;

  return (
    <Container>
      <TitleContainer>
        <ShieldIcon />
        <Title>Compra 100% segura e protegida</Title>
      </TitleContainer>

      <Paragraph>
        Você está em um ambiente seguro! Todos os seus dados são criptografados
        com SSL e mantidos sob sigilo. Se precisar de ajuda, entre em contato
        com <Strong>{supportEmail}</Strong>
      </Paragraph>

      {steps === 0 &&
        offer?.offer?.details?.payment_methods?.credit_card &&
        offer?.offer?.details?.amount_visualization === "installment" &&
        !(
          offer?.offer?.free_installments === offer?.offer?.max_installments
        ) && (
          <ParagraphAlertInterest>
            *O valor possui acréscimo de{" "}
            {(lastInstallment?.interest_rate * 100).toFixed(2)}% a.m.
          </ParagraphAlertInterest>
        )}

      {steps === 1 &&
      offer?.offer?.details?.payment_methods?.credit_card &&
      installmentSelected?.installment > 1 &&
      !installmentSelected?.free_installment ? (
        <ParagraphAlertInterest>
          *O valor possui acréscimo de{" "}
          {(installmentSelected?.interest_rate * 100)?.toFixed(2)}% a.m.
        </ParagraphAlertInterest>
      ) : (
        showMessagesInterestRate && (
          <ParagraphAlertInterest>
            *O valor possui acréscimo {interest?.toFixed(2)}% a.m.
          </ParagraphAlertInterest>
        )
      )}
    </Container>
  );
};

export default MoreInformations;
